import { render, staticRenderFns } from "./ModalWelcome.vue?vue&type=template&id=8b1ccff0&scoped=true&lang=pug"
import script from "./ModalWelcome.vue?vue&type=script&lang=js"
export * from "./ModalWelcome.vue?vue&type=script&lang=js"
import style0 from "./ModalWelcome.vue?vue&type=style&index=0&id=8b1ccff0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1ccff0",
  null
  
)

export default component.exports